import { render, staticRenderFns } from "./SafeAutoDebitHistory.vue?vue&type=template&id=87c99186&scoped=true&"
import script from "./SafeAutoDebitHistory.vue?vue&type=script&lang=js&"
export * from "./SafeAutoDebitHistory.vue?vue&type=script&lang=js&"
import style0 from "./SafeAutoDebitHistory.vue?vue&type=style&index=0&id=87c99186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c99186",
  null
  
)

export default component.exports